/**
 * 雇用形態
 *
 * @param props
 * @return {JSX.Element|null}
 * @constructor
 */
export const JobType = (props) => {
    if (!props.viewedJob.jobType) {
        return null;
    }

    return (
        <div className="p-job_tag_wrap">
            <p className="p-job_tag">
                <img src="/webfront/images/icon/jobtype_bluegray.svg" width="11" height="12" alt={props.translations.job_type} />{props.viewedJob.jobType}
            </p>
        </div>
    );
}
